<template>
  <div>
    <h1 :class="timer_class">
      <span id="minutes" :style="font_timer_size">
        <input
          type="number"
          v-model="minutes"
          id="minutes_input"
          placeholder="min"
          min="1"
          max="1440"
          @change="setDefaultMin($event)"
        />
      </span>
      <span id="middle">:</span>
      <span id="seconds"
        ><small>{{ seconds }}</small></span
      >
    </h1>

    <h6 v-text="sound_btn.text" class="gold"></h6>
    <b-button-group>
      <b-button
        :class="{
          'btn btn-primary': audio_playing === 'ambient_sound',
          'btn btn-secondary': audio_playing !== 'ambient_sound',
        }"
        name="ambient_sound"
        @click.prevent="toggleMusic($event.target)"
      >
        <i
          :class="{
            'fas fa-volume-up': audio_playing === 'ambient_sound',
            'fas fa-volume-mute': audio_playing !== 'ambient_sound',
          }"
        ></i>
        Ambient
      </b-button>
      <b-button
        :class="{
          'btn btn-primary': audio_playing === 'nature_sound',
          'btn btn-secondary': audio_playing !== 'nature_sound',
        }"
        name="nature_sound"
        @click.prevent="toggleMusic($event.target)"
      >
        <i
          :class="{
            'fas fa-volume-up': audio_playing === 'nature_sound',
            'fas fa-volume-mute': audio_playing !== 'nature_sound',
          }"
        ></i>
        Nature
      </b-button>
      <b-button
        :class="{
          'btn btn-primary': audio_playing === 'ocean_sound',
          'btn btn-secondary': audio_playing !== 'ocean_sound',
        }"
        name="ocean_sound"
        @click.prevent="toggleMusic($event.target)"
      >
        <i
          :class="{
            'fas fa-volume-up': audio_playing === 'ocean_sound',
            'fas fa-volume-mute': audio_playing !== 'ocean_sound',
          }"
        ></i>
        Ocean
      </b-button>
    </b-button-group>

    <div id="buttons" class="mt-4">
      <b-button
        variant="outline-primary"
        v-if="!timer"
        @click="startTimerWithClick"
        ><i class="far fa-play-circle fa-2x"></i
      ></b-button>

      <b-button variant="outline-secondary" v-if="timer" @click="stopTimer"
        ><i class="far fa-pause-circle fa-2x"></i
      ></b-button>

      <b-button variant="outline-danger" v-if="resetButton" @click="resetTimer"
        ><i class="fas fa-step-backward fa-1x"></i
      ></b-button>

      <b-button
        variant="outline-success"
        v-if="resetButton && !timer"
        @click="meditationSubmit"
        ><i class="fas fa-cloud-upload-alt fa-2x"></i> Save</b-button
      >
    </div>

    <h5
      v-if="message.class === 'text-success'"
      class="text-success text-center m-3"
    >
      <span v-text="message.text"></span><br />
      <i class="fas fa-check fa-2x"></i>
    </h5>
    <p v-else class="m-3" :class="message.class" v-text="message.text"></p>
  </div>
</template>

<script>
import axios from "axios";

const ambient_sound = new Audio(
  "https://media.iamconnected.com/sounds/ambient_1.mp3"
);
const ocean_sound = new Audio(
  "https://media.iamconnected.com/sounds/ocean_1.mp3"
);
const nature_sound = new Audio(
  "https://media.iamconnected.com/sounds/nature_1.mp3"
);
const chime_sound = new Audio(
  "https://media.iamconnected.com/sounds/chime_1.mp3"
);
var fadeTimer = false;

import NoSleep from "nosleep.js";
var noSleep = new NoSleep();

export default {
  name: "CountdownTimer",
  props: {},
  data() {
    return {
      default_min: 30,
      totalTime: 0,
      timer: null,
      timer_class: "gold",
      timer_active: 1,
      font_timer_size: "font-size: 2.5rem;",
      resetButton: false,
      message: {
        class: "text-dark",
        text: "Relax and let go...",
      },
      number_mins: 30,
      sound_btn: {
        class: "btn btn-outline-secondary",
        icon: "fas fa-volume-up",
        status: 0,
        text: "Play Ambient Music",
        track: "",
      },
      audio_fading: 0,
      audio_playing: "",
      uploading: 0,
    };
  },
  mounted() {
    this.totalTimeSetDefault();

    // document.addEventListener('visibilitychange', () => {
    // 	//NOTE: Instead of relying on the interval callback each second to control the timer,
    // 	//		we calculate the timer each second by looking at the isoString stored
    // 	let nativeMeditation = localStorage.getItem("meditation_time_natively");
    // 	let totalTime = localStorage.getItem("meditation_time_natively_total_time");

    // 	if(nativeMeditation && this.timer !== null) {

    // 		console.log("OnFocus");

    // 		let nativeTime = Date.parse(nativeMeditation);

    // 		let timeNow = (new Date()).getTime();

    // 		let diff = (timeNow - nativeTime) / 1000;

    // 		let difference = totalTime - diff.toFixed(0);

    // 		this.totalTime = difference;
    // 	}
    // });

    //NOTE: See if the meditation time should be running
    let nativeMeditation = localStorage.getItem("meditation_time_natively");
    let totalTime = localStorage.getItem("meditation_time_natively_total_time");
    let isPaused = localStorage.getItem("meditation_time_natively_paused");
    let musicPlaying = localStorage.getItem("meditation_music_playing");

    console.log("Music playing: " + musicPlaying);

    if (musicPlaying != "") {
      //NOTE: Can't auto play music becuase user hasn;t interacted with document yet.
      //		Not sure if anyway to override this?
      //this.toggleMusic({name: musicPlaying});
    }

    if (nativeMeditation !== undefined && nativeMeditation !== null) {
      console.log("Resuming meditation session");

      if (isPaused) {
        console.log("is paused");

        this.font_timer_size = "font-size: 5rem;";

        this.totalTime = totalTime;

        this.timer = null;
        this.resetButton = true;
        this.timer_class = "text-muted";
      } else {
        console.log("is running");

        let nativeTime = Date.parse(nativeMeditation);

        let timeNow = new Date().getTime();

        let diff = (timeNow - nativeTime) / 1000;

        let difference = totalTime - diff.toFixed(0);

        //NOTE: Set the total time to seconds. Difference is in milliseconds
        this.totalTime = difference;

        this.startTimer();

        //this.takeTimeSnapshot(false);
      }
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => this.countdown(), 1000);
      noSleep.enable();
      this.resetButton = true;
      this.timer_class = "text-success";
      this.font_timer_size = "font-size: 5rem;";
    },
    setDefaultMin(e) {
      console.log(e.target.value);
      if(e.target.value < 0 || e.target.value > 14400){
        this.default_min = 30;
        e.target.value = 30;
      }else {
        this.default_min = e.target.value;
      }
      console.log("setDefaultMin:" + this.default_min);
    },
    startTimerWithSound() {
      this.startTimer();

      chime_sound.play();
    },
    startTimerWithClick() {
      this.startTimerWithSound();

      this.takeTimeSnapshot(false);
    },

    takeTimeSnapshot(isPaused) {
      //NOTE: Add a cookie to log when this timer started
      let startTimeAsIsoString = new Date();
      startTimeAsIsoString = startTimeAsIsoString.toISOString();
      localStorage.setItem("meditation_time_natively", startTimeAsIsoString);
      localStorage.setItem(
        "meditation_time_natively_total_time",
        this.totalTime
      );

      if (isPaused) {
        localStorage.setItem("meditation_time_natively_paused", "true");
      } else {
        localStorage.removeItem("meditation_time_natively_paused");
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        noSleep.disable();
      }

      this.timer = null;
      this.resetButton = true;
      this.timer_class = "text-muted";

      //NOTE: Clear the meditaiton timer storeage
      this.takeTimeSnapshot(true);
    },
    resetTimer() {
      this.stopTimer();
      this.totalTime = this.default_min * 60;
      this.timer = null;
      this.resetButton = false;
      this.timer_class = "gold";
      this.font_timer_size = "font-size: 2.5rem;";
      this.uploading = 0;

      //NOTE: Clear the meditaiton timer storeage
      localStorage.removeItem("meditation_time_natively");
      localStorage.removeItem("meditation_time_natively_total_time");
      localStorage.removeItem("meditation_time_natively_paused");
      localStorage.removeItem("meditation_music_playing");
    },
    padTime: function(time) {
      return (time < 10 ? "0" : "") + time;
    },
    countdown() {
      if (this.totalTime >= 1) {
        this.totalTime--;
        if (this.totalTime <= 5 && this.audio_fading == 0) {
          this.audio_fading = 1;
          this.music_fade();
        }
      } else {
        if (this.uploading == 0) {
          this.totalTime = 0;
          this.playChime();
          this.meditationSubmit();
        }
      }
    },
    meditationSubmit() {
      var _this = this;

      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("date", "now");
      params.append("totalTime", _this.totalTime);
      params.append("default_min", _this.default_min);

      var now = new Date();
      var TZ_offset = now.getTimezoneOffset();
      params.append("timezone_offset", TZ_offset);

      _this.message.class = "text-info";
      _this.message.text = "Uploading Data...";
      _this.uploading = 1;

      axios({
        url: _this.$store.state.api_url + "meditationAdd",
        params: params,
      })
        .then(function(response) {
          if (response.data.status == 1) {
            _this.message.class = "text-success";
            _this.message.text = "Your meditation data was uploaded.";

            /*_this.$parent.meditationDateGet();*/
            _this.resetTimer();
          } else {
            _this.message.text = "Error uploading your meditation data.";
            _this.message.class = "text-danger";
            this.timer = null;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    music_fade() {
      if (
        this.audio_playing !== "" &&
        eval(this.audio_playing).volume > 0.002
      ) {
        if (eval(this.audio_playing).volume > 0.005) {
          console.log(eval(this.audio_playing).volume);
          eval(this.audio_playing).volume -= 0.004;
          fadeTimer = setTimeout(this.music_fade, 50);
        } else {
          eval(this.audio_playing).volume = 0;
          eval(this.audio_playing).pause();
          eval(this.audio_playing).currentTime = 0;
          this.audio_playing = "";
          this.audio_fading = 0;
          console.log(this.audio_playing + " is off");
        }
      }
    },
    toggleMusic(e) {
      console.log(e.name);

      localStorage.setItem("meditation_music_playing", e.name);

      ambient_sound.pause();
      ocean_sound.pause();
      nature_sound.pause();

      clearTimeout(fadeTimer);

      if (this.audio_playing == e.name) {
        this.audio_playing = "";
      } else {
        this.audio_playing = e.name;
        eval(e.name).play();
        eval(e.name).volume = 1;
        eval(e.name).loop = true;
      }
    },
    totalTimeSetDefault() {
      var _this = this;
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      axios({
        url: _this.$store.state.api_url + "meditation_user_time_get",
        params: params,
      })
        .then(function(response) {
          let nativeMeditation = localStorage.getItem(
            "meditation_time_natively"
          );
          if (nativeMeditation == undefined && nativeMeditation == null) {
            //NOTE: Only do this if there isn't a meditation time going on as this seems to clear it.
            _this.default_min = response.data.minutes;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      this.totalTime = this.default_min * 60;
    },
    playChime() {
      chime_sound.currentTime = 0;
      chime_sound.volume = 1;
      chime_sound.loop = false;
      chime_sound.play();
    },
  },
  computed: {
    minutes: {
      get() {
        const minutes = Math.floor(this.totalTime / 60);
        return this.padTime(minutes);
      },
      set(newValue) {
        console.log(newValue);
        const minutes = Math.floor(newValue);
        return this.padTime(minutes);
      },
    },
    seconds() {
      const seconds = this.totalTime - this.minutes * 60;
      return this.padTime(seconds);
    },
    startTotal() {
      return this.totalTime;
    },
  },
  watch: {
    default_min(val) {
      this.totalTime = val * 60;
    },
  },
};
</script>

<style scoped>
#minutes_input {
  width: 180px;
  text-align: center;
  border: none;
  color: inherit !important;
  font-size: inherit;
  font-weight: inherit;
}
</style>
